export default "__VITE_ASSET__CPBNXrVx__"